module.exports = __webpack_public_path__ + "package2.png?38333695a27181bb5a6615ea1b97a3ac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/package2.png
// module id = 27
// module chunks = 0